import { useCallback, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isNoneSubMode, isSubConsultMode, isSubCreateMode, isSubUpdateMode } from '../../utils/store/store-utils';
import QCXFinalFormWizard from '../../shared-components/final-form-wizard/QCXFinalFormWizard';
import QCXHouseForm from './QCXHouseForm';
import { selectSubMode } from '../../features/house/HouseSlice';
import QCXHouseVolumesForm from './QCXHouseVolumesForm';
import QCXHouseCustosForm from './QCXHouseCustosForm';

export default function QCXHouseWizardFinalForm({
  isIdle,
  isLoading,
  isFailure,
  isCreate,
  isConsult,
  isUpdate,
  isLocked,
  isBackgroundCreate,
  isBackgroundDelete,
  isSubBackgroundCreate,
  isSubBackgroundConsult,
  isSubBackgroundUpdate,
  isSubBackgroundDelete,
  isPreparingAction,
  handleSubmit,
  handleCustomSaveBy,
  handleAlternativeSave,
  model,
  handleChangeModel,
  handleChangeToCreate,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  handleChangeToBackgroundCreate,
  handleChangeToBackgroundDelete,
  handleResetBackgroundMode,
  authInfo = {},
  requiredRoles = [],
  children,
  openAskRepassarMoedasPopUp,
  openAskLimparAcrescimosDeducoes,
  tipoEmbarque,
  setTipoEmbarque,
  cargaPerigosa,
  setCargaPerigosa,
  type,
  ...restProps
}) {
  const { t } = useTranslation();


  const wizardSteps = useMemo(() => {
    const stepsLabels = [
      t('com.muralis.qcx.agenciamento.wizardSteps.cabecalho'),
      t('com.muralis.qcx.agenciamento.wizardSteps.mercadoria'),
      t('com.muralis.qcx.agenciamento.wizardSteps.totais'),
    ];

    return stepsLabels;
  }, []);

  const subMode = useSelector(selectSubMode);

  const isSubNone = useMemo(() => isNoneSubMode(subMode), [subMode]);

  const isSubCreate = useMemo(() => isSubCreateMode(subMode), [subMode]);

  const isSubConsult = useMemo(() => isSubConsultMode(subMode), [subMode]);

  const isSubUpdate = useMemo(() => isSubUpdateMode(subMode), [subMode]);

  const checkIfIsAlternativeSaveByStep = (currentStep) => false;

  return (
      <QCXFinalFormWizard
        steps={wizardSteps}
        initialValues={model} 
        handleChangeValues={handleChangeModel}
        isConsult={isConsult}
        isUpdate={isUpdate}
        isBackgroundCreate={isBackgroundCreate}
        isSubNone={isSubNone}
        isSubCreate={isSubCreate}
        isSubConsult={isSubConsult}
        isSubUpdate={isSubUpdate}
        handleSubmit={handleSubmit}
        checkIfIsAlternativeSaveByStep={checkIfIsAlternativeSaveByStep}
        handleAlternativeSave={handleAlternativeSave}
        handleChangeToCreate={handleChangeToCreate}
        handleChangeToConsult={handleChangeToConsult}
        handleChangeToUpdate={handleChangeToUpdate}
        handleCancelUpdate={handleCancelUpdate}
        handleChangeToBackgroundCreate={handleChangeToBackgroundCreate}
        handleResetBackgroundMode={handleResetBackgroundMode}
        persistValuesOnStepChange
        {...restProps}
      >
        {(formProps) => (
          <QCXHouseForm
            key="cabecalho"
            isConsult={isConsult}
            isUpdate={isUpdate}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            tipoEmbarque={tipoEmbarque}
            setTipoEmbarque={setTipoEmbarque}
            cargaPerigosa={cargaPerigosa}
            setCargaPerigosa={setCargaPerigosa}
            type={type}
            {...formProps}
          />
        )}
        {(formProps) => (
           <QCXHouseVolumesForm
            key="volumes"
            isConsult={isConsult}
            isUpdate={isUpdate}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            rowsItens={[]}
            {...formProps}
         />
        )}
        {(formProps) => (
           <QCXHouseCustosForm
            key="custos"
            isConsult={isConsult}
            isUpdate={isUpdate}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            {...formProps}
         />
        )}
      </QCXFinalFormWizard>
  );
}
